import {ActionCreator, createAction} from '@packages/utilities/create-action';
import type {OnChangeMeta} from '@packages/systems/design-system/WebflowUnitInput';
import type {LayoutMatrix, LayoutUpdateAction, LayoutStyles} from './types';

const LAYOUT_STRUCTURE_UPDATED = 'LAYOUT_STRUCTURE_UPDATED';

const updateLayoutStructure: ActionCreator<
  typeof LAYOUT_STRUCTURE_UPDATED,
  {
    action: LayoutUpdateAction;
    layoutElementId: string;
    targetLayoutMatrix?: LayoutMatrix;
    targetLayoutStyles?: LayoutStyles;
    meta?: {
      location?: string;
      changeType?: OnChangeMeta['changeType'];
    };
  }
> = createAction(LAYOUT_STRUCTURE_UPDATED);

export const ActionTypes = {
  LAYOUT_STRUCTURE_UPDATED,
} as const;

export const Actions = {
  updateLayoutStructure,
} as const;
